import React, { useEffect, useRef } from "react";
import { Molecule } from "openchemlib/full";

interface MoleculeDisplayProps {
  smiles: string;
}

const MoleculeDisplay: React.FC<MoleculeDisplayProps> = ({ smiles }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!smiles || !canvasRef.current) return;

    try {
      // Convert SMILES to molecule
      const mol = Molecule.fromSmiles(smiles);
      const ctx = canvasRef.current.getContext("2d");

      if (ctx) {
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        const svg = mol.toSVG(250, 250);
        const img = new Image();
        img.onload = () => {
          ctx.drawImage(img, 0, 0);
        };
        img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
      }
    } catch (error) {
      console.error("Error rendering molecule:", error);
    }
  }, [smiles]);

  return <canvas ref={canvasRef} width={300} height={300} />;
};

export default MoleculeDisplay;
